import { createUniqueId } from "solid-js"
import { useLanguage } from "@/context/language"
import "./brand.css"

export function CoworkBrand(props: { size?: number; appearance?: "auto" | "light" | "dark"; class?: string }) {
  const language = useLanguage()
  const clip = createUniqueId()
  const size = () => props.size ?? 32
  return (
    <span
      role="img"
      aria-label={language.t("cowork.logo.alt")}
      data-andmera-brand
      data-appearance={props.appearance ?? "auto"}
      class={`cowork-brand ${props.class ?? ""}`}
      style={{ "font-size": `${size() * 0.75}px`, gap: `${size() * 0.25}px` }}
    >
      <svg width={size()} height={size()} viewBox="0 0 64 64" aria-hidden="true" class="cowork-brand-mark">
        <defs>
          <clipPath id={clip}>
            <rect x="0" y="8" width="64" height="48" />
          </clipPath>
        </defs>
        <g clip-path={`url(#${clip})`}>
          <path d="M11 58 L32 4 L53 58" fill="none" stroke="currentColor" stroke-width="5" stroke-linejoin="miter" />
        </g>
        <rect x="18" y="36" width="28" height="3" fill="currentColor" />
        <rect x="16" y="42" width="32" height="6" fill="currentColor" />
      </svg>
      <span aria-hidden="true">{language.t("cowork.login.brand")}</span>
    </span>
  )
}
